import CollectionModule from 'client/store/modules/CollectionModule';
import OrganizationInvoiceApi from 'api/v2/OrganizationInvoiceApi';

export class OrganizationInvoiceCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();

    module.actions.viewInvoicePdf = (...params) => this.viewInvoicePdf(...params);
    return module;
  }
}

export default new OrganizationInvoiceCollectionClass(OrganizationInvoiceApi, 'id').extractModule();
